<ion-header>
    <ion-toolbar>
        <h6 id="label" role="heading" aria-level="1" class="selects-detail-header">{{ question.text }}</h6>
    </ion-toolbar>
</ion-header>
<ion-content>
    <ion-radio-group [(ngModel)]="answer">
        <ion-list id="selects-detail-radio-list" role="group" aria-labelledby="label">
            <ion-item button *ngFor="let item of question.items; let last=last" (click)="onClickRadio(item)" [attr.default]="item.default===true?true: null" attr.last={{last}}>
                <ion-label [innerHTML]="item.text"></ion-label>
                <ion-radio
                    id="selects-detail-radio-item-{{item.id}}"
                    readonly="true"
                    tabindex="-1"
                    color="participant"
                    slot="start"
                    [value]="item.id"></ion-radio>
            </ion-item>
        </ion-list>
    </ion-radio-group>
</ion-content>
